import { PortfolioDetail, WEDDINGS_CFG } from "@/components/Portfolio";
export default function WeddingDetail() {
  return <PortfolioDetail cfg={WEDDINGS_CFG} />;
}
